import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';

import { SportsService } from '@core/sports/sports.service';

/**
 * Topbar control that scopes every dashboard / list / scoring page to a
 * single sport. Hidden when the academy only has one registered sport.
 */
@Component({
  selector: 'app-sport-switcher',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MatButtonModule, MatIconModule, MatMenuModule, MatTooltipModule],
  templateUrl: './sport-switcher.component.html',
  styleUrl: './sport-switcher.component.scss'
})
export class SportSwitcherComponent {
  private readonly sports = inject(SportsService);

  protected readonly available = computed(() => this.sports.availableSports());
  protected readonly current = computed(() => this.sports.currentSport());
  protected readonly multi = computed(() => this.available().length > 1);

  select(key: string): void {
    this.sports.setCurrentSport(key);
  }
}
